export default __webpack_public_path__ + "static/media/vin_logo.57aa90ea.png";